import { ILedgerHistoryFilters } from './types'

export const DEFAULT_LEDGER_HISTORY_PAGE_SIZE = 25
export const LEDGER_HISTORY_PAGE_SIZE_OPTIONS = [10, 25, 50]

export const DEFAULT_LEDGER_HISTORY_FILTERS: ILedgerHistoryFilters = {
  dateRange: {},
  wallet: '',
  direction: '',
}
